import React, { Fragment } from 'react';
import { StyledButton, StyledIcon } from './styled';
import loadingIcon from '../../../public/static/image/icons/loading.svg';

const Button = ({ loading, disabled, icon: Icon, children, outline, FaIcon, ...props }) => (
  <StyledButton disabled={disabled || loading} outline={outline} {...props}>
    {loading ? (
      <img src={loadingIcon} alt="Loading" />
    ) : (
      <Fragment>
        {Icon && <StyledIcon src={Icon} outline={outline} />}
        {FaIcon && FaIcon}
        {children}
      </Fragment>
    )}
  </StyledButton>
);
export default Button;
